// extracted by mini-css-extract-plugin
module.exports = {"emphasizedText":"az_lO","headline":"az_mO"};